import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Radio,
  FormControlLabel,
  Link,
  RadioGroup,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../EmployeeDetailPolicies/EmployeeDetailPolicies.scss";
import SlidingPanel from "react-sliding-side-panel";
import { GridCloseIcon } from "@mui/x-data-grid";
import DatePicker from "../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";

function EmployeeDetailPolicies() {
  const [uploadFile, setUploadFile] = React.useState(false);
  const [expanded, setExpanded] = React.useState<string | false>("panel");
  const [toggle, setToggle] = React.useState(true);
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [addNominee, setAddNominee] = React.useState(false);
  const [addHealth, setAddHealth] = React.useState(false);
  const [addMember, setAddMember] = React.useState(false);
  const [addPolicy, setAddPolicy] = React.useState(false);
  const [checktick, setchecktick] = React.useState(false);

  const [fullName, setFullName] = React.useState("");
  const [relationEmployee, setRelationEmployee] = React.useState("");
  const [selectMember, setSelectMember] = React.useState("Vikas Saini");
  const [selectFamily, setSelectFamily] = React.useState("");
  const [nomineeDob, setNomineeDob] = React.useState<Date | null>(new Date());
  const [age, setAge] = React.useState("");
  const [healthEcard, setHealthEcard] = React.useState("PB223674780");
  const [selectGrade, setSelectGrade] = React.useState("");

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  const [empGradeData, setEmpGradeData] = React.useState<
    Array<{
      sum_insured: string;
      emp_count: string;
      deleteable: boolean;
      features: Array<string>;
    }>
  >([{ sum_insured: "", emp_count: "", deleteable: false, features: [] }]);
  const handleClick = () => {
    setToggle(true);
  };
  const handleClicked = () => {
    setToggle(false);
  };
  const handleClicktoogle = () => {
    setToggle(true);
  };

  const relationEmployee_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];
  const selectMember_data = [
    { key: "Vikas Saini", value: "Vikas Saini" },
    { key: "Vishu Saini", value: "Vishu Saini" },
  ];
  const selectFamily_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];
  const selectGrade_data = [
    { key: "Grade 1 - SI(5 Lakhs)", value: "Grade 1 - SI(5 Lakhs)" },
    { key: "Grade 2 - SI(6 Lakhs)", value: "Grade 2 - SI(6 Lakhs)" },
    { key: "Grade 3 - SI(7 Lakhs)", value: "Grade 3 - SI(7 Lakhs)" },
    { key: "Grade 4 - SI(8 Lakhs)", value: "Grade 4 - SI(8 Lakhs)" },
    { key: "Grade 5 - SI(9 Lakhs)", value: "Grade 5 - SI(9 Lakhs)" },
  ];
  const member_table_data = [
    {
      member_id: "EMP001",
      member_type: " Employee",
      member_name: "Vikas",
      relation_employee: "Self",
      dob: "22-feb-1999",
      age: "24 Years",
      addition_type: "Regular Enrolment",
      enrollment_date: "24-04-2023",
      enrollment_time: "04:00 PM",
    },
    {
      member_id: "EMP002",
      member_type: " Employee",
      member_name: "Vikas",
      relation_employee: "Self",
      dob: "22-feb-1999",
      age: "24 Years",
      addition_type: "Regular Enrolment",
      enrollment_date: "24-04-2023",
      enrollment_time: "04:00 PM",
    },
  ];
  const nominee_table_data = [
    {
      nominee_name: "Vikas",
      relation_employee_nominee: "Self",
      dob_nominee: "22-feb-1999",
      age_nominee: "24 Years",
      addition_type_nominee: "Regular Enrolment",
      date: "24-04-2023",
      time: "04:00 PM",
    },
    {
      nominee_name: "Vikas",
      relation_employee_nominee: "Self",
      dob_nominee: "22-feb-1999",
      age_nominee: "24 Years",
      addition_type_nominee: "Regular Enrolment",
      date: "24-04-2023",
      time: "04:00 PM",
    },
  ];
  const ecard_table_data = [
    {
      member_type_ecard: "Employee",
      member_name_ecard: "Vikas",
      health_number: "GHY1236543",
      health_document: "Health Lorem",
      date: "24-04-2023",
      time: "04:00 PM",
    },
    {
      member_type_ecard: "Employee",
      member_name_ecard: "Vikas",
      health_number: "GHY1236543",
      health_document: "Health Lorem",
      date: "24-04-2023",
      time: "04:00 PM",
    },
  ];

  const add_policy_data = [
    {
      checkbox_status: false,
      check_status: "",
      active_policy: "PVAZ23456788",
      product_type: "Group Health",
      insurer: "Bajaj Allianz",
      basic_config: "1E+1S+1C+1C+1C+1C",
      individual_config: "Nill",
    },
    {
      checkbox_status: false,
      check_status: "",
      active_policy: "PVAZ23456788",
      product_type: "Group Term",
      insurer: "Bajaj Allianz",
      basic_config: "1E+1S+1C+1C+1C",
      individual_config: "1P+1P",
    },
  ];

  const [type, setType] = useState("");
  useEffect(() => {
    const windowURL = window.location.search;
    const params = new URLSearchParams(windowURL);

    const type = params.get("type");

    setType(type === null ? "" : type);
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        <Grid xs={12} className="text-right">
          <Link
            underline="none"
            className="greenBtn addfile"
            onClick={() => {
              setAddPolicy(true);
            }}
          >
            Assign Policy
          </Link>
        </Grid>
      </Grid>
      <Box className="detailSection mt-4">
        <div className="sectionTitle">
          <h4>Policies Details</h4>
        </div>
        <Box className="employee_detailpolicy">
          {empGradeData.map((data, index) => (
            <Accordion
              className="Accordion_section employee_policiesSection accordion_padding"
              onChange={handleChange("panel1")}
            >
              <Grid container spacing={0}>
                <Grid xs={10} className="px-0">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{
                      display: "inline-block",
                      width: "100%",
                      padding: "0",
                    }}
                  >
                    <Typography className="title" style={{ width: "100%" }}>
                      <Grid container spacing={3} style={{ paddingLeft: "0" }}>
                        <Grid xs={6}>
                          <h5>PB265764</h5>
                        </Grid>
                        <Grid
                          xs={6}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <h6>2 Members</h6> <h6>Group Health</h6>
                          <h6>HDFC Ergo</h6>
                        </Grid>
                      </Grid>
                    </Typography>
                  </AccordionSummary>
                </Grid>
                <Grid
                  xs={2}
                  style={{
                    alignSelf: "Center",
                    display: "flex",
                    justifyContent: "end",
                    padding: "0",
                  }}
                >
                  {data.deleteable == false ? null : (
                    <div className="text-right" style={{ alignSelf: "center" }}>
                      <Link
                        className="redBtn delete ml-3"
                        underline="none"
                        onClick={() => {
                          setEmpGradeData((addFeature) =>
                            empGradeData.filter((_, i) => i !== index)
                          );
                        }}
                      >
                        Remove
                      </Link>
                    </div>
                  )}
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{ paddingRight: "0" }}
                  >
                    <Typography></Typography>
                  </AccordionSummary>
                </Grid>
              </Grid>
              <AccordionDetails style={{ padding: "0" }}>
                <Grid container spacing={3}>
                  <Grid xs={12} className="policies_detail">
                    <div>
                      <h4>
                        Policy Number
                        <span>PB265764</span>
                      </h4>
                    </div>
                    <div>
                      <h4>
                        Sum Insured <span>₹ 5 00 000</span>
                      </h4>
                    </div>
                    <div>
                      <h4>
                        Start Date <span>20-04-2023</span>
                      </h4>
                    </div>
                    <div>
                      <h4>
                        End Date <span>20-04-2024</span>
                      </h4>
                    </div>
                    <div>
                      <h4>
                        Insurer Name<span>HDFC Ergo</span>
                      </h4>
                    </div>
                    <div>
                      <h4>
                        Product Type <span>Group Health</span>
                      </h4>
                    </div>
                    <div>
                      <Link className="networkhosplist">
                        Network Hospital List
                      </Link>
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid xs={6}>
                    <h4 className="subHeading">Member Details</h4>
                  </Grid>
                  {type === "employee" ? (
                    <Grid xs={6} style={{ textAlign: "right" }}>
                      <div className="actionBtns">
                        <Link
                          className="greenBtn addfile"
                          sx={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setAddMember(true)}
                        >
                          Add Member
                        </Link>
                      </div>
                    </Grid>
                  ) : null}
                </Grid>
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <div className="employeeDetailtable">
                      <div
                        className="employeePolicy_table"
                        style={{ overflow: "hidden" }}
                      >
                        <ul className="heading">
                          <li>Member ID </li>
                          <li>Member Type</li>
                          <li>Member Name</li>
                          <li>Relationship with Employee</li>
                          <li>DOB</li>
                          <li>Age</li>
                          <li>Addition/Removal Type</li>
                          <li>Enrolment Date</li>
                          <li>Enrolment Time</li>
                          <li>Action</li>
                        </ul>

                        {member_table_data.map((data, index) => (
                          <ul className="subheading">
                            <li>{data.member_id}</li>
                            <li>{data.member_type}</li>
                            <li>{data.member_name}</li>
                            <li>{data.relation_employee}</li>
                            <li>{data.dob}</li>
                            <li>{data.age}</li>
                            <li>{data.addition_type}</li>
                            <li>{data.enrollment_date}</li>
                            <li>{data.enrollment_time}</li>
                            <li
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <Link
                                className="redBtn delete ml-0"
                                onClick={() => {
                                  setDeleteStatus(true);
                                }}
                                sx={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                              ></Link>
                            </li>
                          </ul>
                        ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>

                {/* nominee section */}
                <Grid container spacing={3}>
                  <Grid xs={6}>
                    <h4 className="subHeading">Nominee Details</h4>
                  </Grid>
                  {type === "employee" ? (
                    <Grid xs={6} style={{ textAlign: "right" }}>
                      <div className="actionBtns">
                        <Link
                          className="greenBtn addfile"
                          sx={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => setAddNominee(true)}
                        >
                          Add Nominee
                        </Link>
                      </div>
                    </Grid>
                  ) : null}
                </Grid>
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <div className="employeeDetailtable">
                      <div
                        className="employeePolicy_table"
                        style={{ overflow: "hidden" }}
                      >
                        <ul className="heading">
                          <li>Nominee Name</li>
                          <li>Relationship with Employee</li>
                          <li>DOB</li>
                          <li>Age</li>
                          <li>Addition/Removal Type</li>
                          <li>Date</li>
                          <li>Time</li>
                          <li>Action</li>
                        </ul>

                        {nominee_table_data.map((data, index) => (
                          <ul className="subheading">
                            <li>{data.nominee_name}</li>
                            <li>{data.relation_employee_nominee}</li>
                            <li>{data.dob_nominee}</li>
                            <li>{data.age_nominee}</li>
                            <li>{data.addition_type_nominee}</li>
                            <li>{data.date}</li>
                            <li>{data.time}</li>
                            <li
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <Link
                                className="redBtn delete ml-0"
                                onClick={() => {
                                  setDeleteStatus(true);
                                }}
                                sx={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                              ></Link>
                            </li>
                          </ul>
                        ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>

                {/* health/ e-card section */}
                <Grid container spacing={3}>
                  <Grid xs={6}>
                    <h4 className="subHeading">Health/E-Card Details</h4>
                  </Grid>
                  <Grid xs={6} style={{ textAlign: "right" }}>
                    <div className="actionBtns">
                      <Link
                        className="greenBtn addfile"
                        sx={{
                          textDecoration: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => setAddHealth(true)}
                      >
                        Add Health/E-Card
                      </Link>
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <div className="employeeDetailtable">
                      <div
                        className="employeePolicy_table"
                        style={{ overflow: "hidden" }}
                      >
                        <ul className="heading">
                          <li>Member Type</li>
                          <li>Member Name</li>
                          <li>Health/E-Card Number</li>
                          <li>Health/E-Card Document</li>
                          <li>Date</li>
                          <li>Time</li>
                          <li>Action</li>
                        </ul>

                        {ecard_table_data.map((data, index) => (
                          <ul className="subheading">
                            <li>{data.member_type_ecard}</li>
                            <li>{data.member_name_ecard}</li>
                            <li>{data.health_number}</li>
                            <li>{data.health_document}</li>
                            <li>{data.date}</li>
                            <li>{data.time}</li>
                            <li
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <Link
                                className="redBtn delete ml-0"
                                onClick={() => {
                                  setDeleteStatus(true);
                                }}
                                sx={{
                                  textDecoration: "none",
                                  cursor: "pointer",
                                }}
                              ></Link>
                            </li>
                          </ul>
                        ))}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

        {/* assign policy popup */}
        <SlidingPanel
          type={"right"}
          isOpen={addPolicy}
          size={75}
          panelClassName="sliding-panel"
          backdropClicked={() => setAddPolicy(false)}
        >
          <div>
            <Grid container spacing={3} alignItems="center">
              <Grid xs={10}>
                <h4 className="mb-0 mt-3 text-left">Assign Policy</h4>
              </Grid>
              <Grid xs={2} textAlign="end" className="mt-2">
                <GridCloseIcon
                  onClick={() => {
                    setAddPolicy(false);
                  }}
                />
              </Grid>
              <Grid xs={12} className="mb-4">
                <hr />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              alignItems="center"
              sx={{ paddingTop: "0" }}
            >
              <Grid xs={12}>
                <div className="scrollable_area">
                  <Grid container spacing={3}>
                    <Grid xs={6}>
                      <div className="addPolicy_info_section">
                        <p className="addPolicy_info_p">
                          Client ID : <span>CL00001</span>
                        </p>
                      </div>
                    </Grid>
                    <Grid xs={12}>
                      <h6 className="policy_subheading">Select Policy </h6>
                    </Grid>
                    <Grid xs={12}>
                      <div className="policy_table">
                        <div
                          className="policy_table_inner"
                          style={{ overflow: "hidden" }}
                        >
                          <ul className="heading">
                            <li>Choose Policy</li>
                            <li>Active Policy Number</li>
                            <li>Product Type</li>
                            <li>Insurer</li>
                            <li>Basic configuration</li>
                            <li>Individual configuration</li>
                          </ul>

                          {add_policy_data.map((data, index) => (
                            <ul className="subheading">
                              <li>
                                <div className="Checkbox">
                                  <input
                                    type="checkbox"
                                    onClick={() => {
                                      index === add_policy_data.length - 1
                                        ? setchecktick(!checktick)
                                        : setchecktick(checktick);
                                    }}
                                    name="check"
                                  />
                                  <label className="employee"></label>
                                </div>
                              </li>
                              <li>{data.active_policy}</li>
                              <li>{data.product_type}</li>
                              <li>{data.insurer}</li>
                              <li>{data.basic_config}</li>
                              <li>{data.individual_config}</li>
                            </ul>
                          ))}
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid xs={6}>
                      <p className="health_ecard">
                        Employee Salary
                        <span>₹ 1,00,000</span>
                      </p>
                    </Grid>
                    <Grid xs={6}>
                      <p className="health_ecard">
                        Employee Salary Bracket
                        <span>₹ 1,00,000 - ₹ 5,00,000</span>
                      </p>
                    </Grid>
                    <Grid xs={6}>
                      <p className="health_ecard">
                        Employee Department
                        <span>Marketing</span>
                      </p>
                    </Grid>
                    <Grid xs={6}>
                      <p className="health_ecard">
                        Employee Designation
                        <span>Deputy Manager</span>
                      </p>
                    </Grid>
                    {checktick === true ? (
                      <Grid xs={6}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Select Grade"
                          value={selectGrade}
                          attrName={setSelectGrade}
                          value_update={updateMasterState}
                          dropdown_data={selectGrade_data}
                          warn_status={false}
                        />
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                </div>
              </Grid>
              <Grid xs={12} className="footer_sec">
                <Link className="save_btn" onClick={() => setAddPolicy(false)}>
                  Submit
                </Link>
              </Grid>
            </Grid>
          </div>
        </SlidingPanel>

        {/* Nominee add policy popup */}
        <SlidingPanel
          type={"right"}
          isOpen={addNominee}
          size={75}
          panelClassName="sliding-panel"
          backdropClicked={() => setAddNominee(false)}
        >
          <div>
            <Grid container spacing={3} alignItems="center">
              <Grid xs={10}>
                <h4 className="mb-0 mt-3 text-left">Fill Nominee Details</h4>
              </Grid>
              <Grid xs={2} textAlign="end" className="mt-2">
                <GridCloseIcon
                  onClick={() => {
                    setAddNominee(false);
                  }}
                />
              </Grid>
              <Grid xs={12} className="mb-4">
                <hr />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              alignItems="center"
              sx={{ paddingTop: "0" }}
            >
              <Grid xs={12}>
                <div className="scrollable_area">
                  <Grid container spacing={3}>
                    <Grid xs={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Full Name"
                        value={fullName}
                        attrName={setFullName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Relationship with employee"
                        value={relationEmployee}
                        attrName={setRelationEmployee}
                        value_update={updateMasterState}
                        dropdown_data={relationEmployee_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <DatePicker
                        class_name="inputField"
                        title="Date of Birth"
                        value={nomineeDob}
                        attrName={setNomineeDob}
                        value_update={updateMasterState}
                        error_message="Please enter Date of Birth"
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Age"
                        value={age}
                        attrName={setAge}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid xs={12} className="footer_sec">
                <Link className="save_btn" onClick={() => setAddNominee(false)}>
                  Submit
                </Link>
              </Grid>
            </Grid>
          </div>
        </SlidingPanel>

        {/* add health ecard policy popup */}
        <SlidingPanel
          type={"right"}
          isOpen={addHealth}
          size={75}
          panelClassName="sliding-panel"
          backdropClicked={() => setAddHealth(false)}
        >
          <div>
            <Grid container spacing={3} alignItems="center">
              <Grid xs={10}>
                <h4 className="mb-0 mt-3 text-left">
                  Add Health/E-Card Details
                </h4>
              </Grid>
              <Grid xs={2} textAlign="end" className="mt-2">
                <GridCloseIcon
                  onClick={() => {
                    setAddHealth(false);
                  }}
                />
              </Grid>
              <Grid xs={12} className="mb-4">
                <hr />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              alignItems="center"
              sx={{ paddingTop: "0" }}
            >
              <Grid xs={12}>
                <div className="scrollable_area">
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <p className="health_ecard">
                        Policy Number
                        <span>PB223674780</span>
                      </p>
                    </Grid>
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Select Member"
                        value={selectMember}
                        attrName={setSelectMember}
                        value_update={updateMasterState}
                        dropdown_data={selectMember_data}
                        warn_status={false}
                      />
                    </Grid>

                    <Grid xs={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Enter Health/E-Card Number"
                        value={healthEcard}
                        attrName={setHealthEcard}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={0} className="mt-4">
                    <Grid xs={10} className="inputField uploadFile mb-5">
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        label="Upload Document"
                        className="textarea"
                      />
                    </Grid>
                    <Grid xs={2}>
                      <Button className="browsebtn">Browse</Button>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid xs={12} className="footer_sec">
                <Link className="save_btn" onClick={() => setAddHealth(false)}>
                  Submit
                </Link>
              </Grid>
            </Grid>
          </div>
        </SlidingPanel>

        {/*Add member policy popup */}
        <SlidingPanel
          type={"right"}
          isOpen={addMember}
          size={75}
          panelClassName="sliding-panel"
          backdropClicked={() => setAddMember(false)}
        >
          <div>
            <Grid container spacing={3} alignItems="center">
              <Grid xs={10}>
                <h4 className="mb-0 mt-3 text-left">Add Member</h4>
              </Grid>
              <Grid xs={2} textAlign="end" className="mt-2">
                <GridCloseIcon
                  onClick={() => {
                    setAddMember(false);
                  }}
                />
              </Grid>

              <Grid xs={12} className="mb-4">
                <hr />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              alignItems="center"
              sx={{ paddingTop: "0" }}
            >
              <Grid xs={12} className="radio_button no-border">
                <>
                  <RadioGroup row defaultValue="existing">
                    <FormControlLabel
                      value="existing"
                      control={<Radio />}
                      label="Choose from existing family member"
                      onClick={handleClicktoogle}
                    />
                    <FormControlLabel
                      // checked
                      value="new"
                      control={<Radio />}
                      label="Add new member"
                      onClick={handleClicked}
                    />
                  </RadioGroup>
                </>
              </Grid>
              <Grid xs={12}>
                <div className="scrollable_area ">
                  <Grid container spacing={3}>
                    {toggle == true ? (
                      <>
                        <Grid xs={6}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Select Family Member"
                            value={selectFamily}
                            attrName={setSelectFamily}
                            value_update={updateMasterState}
                            dropdown_data={selectFamily_data}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <p className="health_ecard">
                            Relationship with Employee
                            <span>Brother</span>
                          </p>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid xs={6}>
                          <RKTextField
                            class_name="inputField"
                            title="Full Name"
                            value={fullName}
                            attrName={setFullName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Relationship with employee"
                            value={relationEmployee}
                            attrName={setRelationEmployee}
                            value_update={updateMasterState}
                            dropdown_data={relationEmployee_data}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6}>
                          <DatePicker
                            class_name="inputField"
                            title="Date of Birth"
                            value={nomineeDob}
                            attrName={setNomineeDob}
                            value_update={updateMasterState}
                            error_message="Please enter Date of Birth"
                            warn_status={false}
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                </div>
              </Grid>

              <Grid xs={12} className="footer_sec">
                <Link className="save_btn" onClick={() => setAddMember(false)}>
                  Submit
                </Link>
              </Grid>
            </Grid>
          </div>
        </SlidingPanel>
      </Box>
    </>
  );
}

export default EmployeeDetailPolicies;
